module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABNUlEQVRYR2NkGGDAOMD2M4w6gKwQUFZWXvD//39/JiamAywsLIU3btx4QG5UkuwAVVVVg3///p2HWQh0SOG9e/cm0M0BKioqDUBL62EWMjIyNt65c6dh1AGjITAaAlQNAQMDA4EPHz7oYzOUmZk5ASgOwjCw4O/fvwtwOYCDg+MhvoIKoyBSUlIqAObtflwGAssABqA8XBqdj00fUM0FYGFliE0OmwMeAC2Qp6YDoGYF3r17dwO6udgccAHoAKzBD9JMTgiA9AHrDcPbt29fIOgAaFkPigYFbKEArAcUkEMI6KCHQMMf4EuEQD0bcNUXJFdGo3XBaAiMhgAwmyYAs9V8WLaje4sIVE98/vz5PcwBuAoYYisnkssBkMFQRziwsrJeoKRFDDKLLAcQ6zti1I06YDQEAOb32CGr5Y10AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/plus.png
// module id = FE4B
// module chunks = 1